import { Injectable, inject } from '@angular/core';
import { GUID } from '../utils/GuidUtils';
import { S3Upload } from '../utils/S3Upload';
import { CampaignsCampaignAdminApiClient } from 'src/app/api/api-campaigns.service.generated';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadImageService {
  private campaignsApi = inject(CampaignsCampaignAdminApiClient);

  private ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png'];

  async uploadImage(uploadKey, file, maxFileSize) {
    try {
      var imageUrl = '';
      var errorMessage = '';
      var result = true;

      if (!file || !this.isValidFile(file)) {
        errorMessage = "Invalid image file";
        result = false;
        return { result, imageUrl, errorMessage };
      }

      if (maxFileSize && !this.isValidFileSize(file, maxFileSize)) {
        const mbSize = maxFileSize / (1024 * 1024);
        errorMessage = `Image file size should not greater than ${mbSize}MB`;
        result = false;
        return { result, imageUrl, errorMessage };
      }

      uploadKey = GUID.newGuid().replace(/-/g, '') + '.' + file.name.split('.').pop(); // preserve extension on s3 key
      const uploadUrl = await lastValueFrom(this.campaignsApi.getUploadUrl(uploadKey));
      const uploadSuccess = await lastValueFrom(S3Upload.upload(uploadUrl, file)); // upload to s3
      if (uploadSuccess) {
        const parts = uploadUrl.split('?');
        const photoUrl = parts[0];
        imageUrl = photoUrl.replace('s3.ap-southeast-1.amazonaws.com/', ''); // trim s3 part to get photo using cloudfront
      }

      return { result, imageUrl, errorMessage };
    } catch (err) {
      console.error('upload failed', err);
    }
  }

  private isValidFileSize(file: File, maxFileSize: number) {
    return file.size < maxFileSize;
  }

  private isValidFile(file: File): boolean {
    return file.name && this.ALLOWED_EXTENSIONS.filter(e => file.name.trim().toLowerCase().endsWith(e)).length > 0;
  }
}
